module.exports = {"350624100":"南诏镇","350624101":"四都镇","350624102":"梅岭镇","350624103":"桥东镇","350624104":"深桥镇","350624105":"太平镇","350624106":"霞葛镇","350624107":"官陂镇","350624108":"秀篆镇","350624109":"西潭镇","350624200":"金星乡","350624202":"白洋乡","350624203":"建设乡","350624204":"红星乡","350624205":"梅洲乡","350624401":"国营西山农场","350624402":"国营湖内林场","350624403":"岭下溪国有防护林场","350624501":"诏安工业园区管委会","350624502":"诏安金都工业集中区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350624.json
// module id = 1116
// module chunks = 0